import React from 'react';

import {ElementMouseEvent} from 'util/Types';

import {CaptionEditableItemContext} from './CaptionEditableItemContext';

export interface CaptionEditableItemProps {
  children: (args: {setItemWidth: (itemWidth: number) => void; itemWidth: number | undefined}) => JSX.Element;
  setItemWidth: (itemWidth: number) => void;
  handleItemClick: (e: ElementMouseEvent) => void;
  itemWidth?: number;
  isImageEditorOpen: boolean;
  setIsImageEditorOpen: (isOpen: boolean) => void;
}

export default function CaptionEditableItem(props: CaptionEditableItemProps): JSX.Element {
  const {children, handleItemClick, setItemWidth, itemWidth, isImageEditorOpen, setIsImageEditorOpen} = props;
  const memoizedContextValue = React.useMemo(
    () => ({isImageEditorOpen, setIsImageEditorOpen}),
    [isImageEditorOpen, setIsImageEditorOpen]
  );
  return (
    <CaptionEditableItemContext.Provider value={memoizedContextValue}>
      <div className="note-item-wrapper" onMouseDown={handleItemClick}>
        {children({setItemWidth, itemWidth})}
      </div>
    </CaptionEditableItemContext.Provider>
  );
}
